import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ProfileForm from '../../Components/venue/ProfileForm';
import VerificationUpload from '../../Components/venue/VerificationUpload';
import RoomManager from '../../Components/venue/RoomManager';
import OrderHistory from '../../Components/venue/OrderHistory';
import WalletPanel from '../../Components/shared/WalletPanel';

const TABS = [
  { id: 'profile', label: 'Profile' },
  { id: 'wallet', label: 'Wallet' },
  { id: 'verification', label: 'Verification' },
  { id: 'rooms', label: 'Rooms & availability' },
  { id: 'history', label: 'Orders' }
];

const VenueDashboard = () => {
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow p-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Venue Dashboard</h1>
        <button onClick={logout} className="text-sm text-gray-600 hover:text-black">Log out</button>
      </header>

      <div className="max-w-4xl mx-auto p-4">
        <nav className="flex gap-2 mb-6 flex-wrap">
          {TABS.map(tab => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-lg text-sm ${activeTab === tab.id ? 'bg-black text-white' : 'bg-white'}`}>
              {tab.label}
            </button>
          ))}
        </nav>

        {activeTab === 'profile' && <ProfileForm />}
        {activeTab === 'wallet' && <WalletPanel />}
        {activeTab === 'verification' && <VerificationUpload />}
        {activeTab === 'rooms' && <RoomManager />}
        {activeTab === 'history' && <OrderHistory />}
      </div>
    </div>
  );
};

export default VenueDashboard;
